<label
  [class]="customClass"
  [for]="for"
  [style.width]="width"
  class="mt-3 text-nowrap"
  [style]="
    'color: #8e98b5;font-weight: 500;display: inline-block;' + customStyle
  "
>
  {{ label | translate }}
  @if (required) {
    <span
      style="color: red"
      [pTooltip]="'ERROR_LIST.FIELD_IS_REQUIRED' | translate"
      tooltipPosition="top"
      >*</span
    >
  }
</label>
